import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
import productTileTemplate from '../../sections/collection/productTileTemplateNosto';

// Select same color or 1st one available
// Add the "more colors" link
// Remove the out of stock colors
// Show / Hide Plus colors depending on Fit selection
const initColor = (formatted_products) => {
  _.each(formatted_products, product => {
    _.each(product.variants, variant => {
      if (typeof variant.online_inventory_style === 'undefined' || variant.online_inventory_style === 0 || variant.online_inventory_style === null) {
        $(`[data-complete-look-products] [data-product-id="${product.id}"] [data-color-value="${variant.color}"]`).remove();
      }
    });
  });

  let selected_color_handle = '';
  if ($('[data-product-details]').length) {
    selected_color_handle = $('[data-product-overview] [data-product-option-color].active').data('handle');
  }

  _.each($('[data-complete-look-products] [data-product-tile]'), item => {
    /* eslint-disable */
    if (selected_color_handle === '') {
      $(item).find('[data-color-swatch]').first().trigger('click');
    } else  {
      if ($(item).find(`[data-color-swatch][data-color-handle="${selected_color_handle}"]`).length) {
        $(item).find(`[data-color-swatch][data-color-handle="${selected_color_handle}"]`).trigger('click');
      } else {
        $(item).find('[data-color-swatch]').first().trigger('click');
      }
    }
    /* eslint-enable */

    if (window.Shopify.shop.includes('staging')) {
      $(item).find('[data-color-swatch]').attr('data-staging-swatch', '');
    }
  });
};

// Keep same height elements to keep them algned
const sameHeight = () => {
  $('[data-complete-look-products] [data-product-tile-title]').removeAttr('style');
  $('[data-complete-look-products] [data-product-tile-price]').removeAttr('style');

  let title_height = 0;
  let price_height = 0;
  _.each($('[data-complete-look-products] [data-product-tile]'), item => {
    const item_title_height = $(item).find('[data-product-tile-title]').height();
    const item_price_height = $(item).find('[data-product-tile-price]').height();

    title_height = item_title_height > title_height ? item_title_height : title_height;
    price_height = item_price_height > price_height ? item_price_height : price_height;
  });

  _.each($('[data-complete-look-products] [data-product-tile]'), item => {
    $(item).find('[data-product-tile-title]').height(title_height);
    $(item).find('[data-product-tile-price]').height(price_height);
  });
};

export default async () => {
  if (!document.querySelector('[data-complete-look-ids-json]') || !document.querySelector('[data-complete-the-look]')) {
    return;
  }

  const complete_look_gql_ids = JSON.parse($('[data-complete-look-ids-json]').html());
  const complete_look_ids = complete_look_gql_ids.map(gql_id => Number(gql_id.replace('gid://shopify/Product/', '')));
  // console.log('complete_look_ids', complete_look_ids);

  let products = await loadProductsByID(complete_look_ids, false, false, true, true, false, true, true);

  // Remove the non-available products
  products = products.filter(product => product.available === true);

  if (products.length === 0) {
    const look_el = document.querySelector('[data-complete-the-look]');
    if (look_el) {
      look_el.remove();
    }

    return;
  }

  console.log('[ASTR] Complete the look API products', products);

  // Reformat product data based on Nosto format
  const products_tiles_html = products.map((product) => `
    ${productTileTemplate({
      'name': product.title,
      'url': product.url,
      'product_id': product.id,
      'price_text': String(product.variants[0].price),
      'custom_fields': {
        'astr-swatches': product.swatches_raw,
        'astr-images_details': product.images_raw,
        'stamped-reviews_average': product.stamped_average,
        'bestseller_style_30': product.bestseller_30,
        'bestseller_style_14': product.bestseller_14,
      },
      'skus': product.variants.map(variant => ({
        name: variant.title,
        id: String(variant.id),
        available: variant.available,
        price: Number(variant.price),
        image_url: variant.image,
        custom_fields: {
          'Color': variant.color,
          'astr-plus_size': variant.style_flag_plus,
        }
      }))
    }, {
      is_slider: false,
      is_simplified: true,
      has_swatches: true,
      has_quickview: true,
      is_search: false,
      is_lookbook: false,
      has_animations: false,
    }, false)}
  `).join('');

  const products_container = document.querySelector('[data-complete-look-products]');
  if (products_container) {
    products_container.innerHTML = products_tiles_html;
    products_container.dataset.totalItems = products.length;

    if (products.length > 2) {
      products_container.classList.add('mobile-scrollable');
    }
  }

  initColor(products);
  sameHeight();
  
  $(document).on('keypress', '[data-complete-look-products] [data-color-swatch]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  $(window).on('resize', _.debounce(() => {
    sameHeight();
  }, 100));
};
